import {
  APPLICATION_TRUST_STATUS,
  getApplicationTrustStatusOptions,
} from 'src/utils/enums/applicationTrustStatus';
import { getAppPortfolioSourceOptions } from 'src/utils/enums/appPortfolioSource';

// A portfolio row is an app, represented by its latest version, and every version including that one
// is listed when the row is expanded.
export const APP_PORTFOLIO_COLUMNS = [
  { key: 'icon', label: '', width: '72px' },
  {
    key: 'displayName',
    label: 'Application',
    width: '27%',
    sortable: true,
    sortKey: 'displayName',
  },
  { key: 'publisher', label: 'Publisher', width: '23%', sortable: true, sortKey: 'publisher' },
  { key: 'version', label: 'Version', width: '17%' },
  { key: 'trustUpdatedOn', label: 'Trust Updated On', width: '15%' },
  { key: 'sources', label: 'Sources', width: '18%' },
  { key: 'versions', label: 'Versions', width: '110px', sortable: true, sortKey: 'versionsCount' },
];

// The same columns one version per row, where a version count has nothing to count and the status
// the expanded rows carry takes its place.
export const APP_PORTFOLIO_VERSION_COLUMNS = [
  ...APP_PORTFOLIO_COLUMNS.filter(column => column.key !== 'versions'),
  { key: 'status', label: 'Status', width: '110px' },
];

export const DEFAULT_PORTFOLIO_SORT = { column: 'displayName', direction: 'asc' };

export const APP_PORTFOLIO_PAGE_SIZE = 25;

// Shared by both views, so a status picked on one still applies after switching to the other. The
// Trusted default is what the sidebar's Apps count counts.
export const DEFAULT_PORTFOLIO_FILTERS = {
  statuses: [APPLICATION_TRUST_STATUS.Trusted],
  sources: [],
};
export const PORTFOLIO_FILTER_OPTIONS = [
  {
    key: 'statuses',
    type: 'checkbox',
    label: 'Status',
    options: getApplicationTrustStatusOptions(),
  },
  {
    key: 'sources',
    type: 'checkbox',
    label: 'Sources',
    options: getAppPortfolioSourceOptions(),
  },
];

export const toggleSort = (sort, sortKey) =>
  sort.column === sortKey
    ? { column: sortKey, direction: sort.direction === 'asc' ? 'desc' : 'asc' }
    : { column: sortKey, direction: 'asc' };
